import * as angular from "angular";

angular
  .module('bringoz.admin.tasks')
  .filter('taskTypeFilter', TaskTypeFilter);

/* @ngInject */
function TaskTypeFilter(tasksConstants) {
  return function (type) {
    return tasksConstants.typesToTitle[type];
  }
}
